React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class extends React.Component
  displayName: 'BoardCreateVisibilityRestrictionsComponent'

  render: t.renderable ->
    { restrictions, visibility } = @props

    t.div '.setting-item-detail', ->
      t.div '.markeddown', ->
        t.p ->
          if restrictions[visibility]
            t.format ['board create visibility', visibility, restrictions[visibility]]
            if visibility == 'public' && restrictions[visibility] != 'none'
              t.span ->
                t.text " #{t.l(['enterprise', 'public-boards-explanation'])}"
          else
            t.format ['enterprise',  'board create visibility', visibility]



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/board-create-visibility-restrictions-component.coffee